
import {
  toast as sonnerToast,
  type ToastT,
} from "sonner";

type ToastProps = {
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  variant?: "default" | "destructive";
} & Omit<React.ComponentProps<typeof sonnerToast>, "position">;

export const useToast = () => {
  const toast = ({ title, description, action, variant = "default", ...props }: ToastProps) => {
    return sonnerToast(title as string, {
      description,
      action,
      className: variant === "destructive" ? "bg-destructive text-destructive-foreground" : undefined,
      duration: 5000,
      ...props,
    });
  };

  return {
    toast,
    dismiss: sonnerToast.dismiss,
    error: (message: string, options?: Omit<React.ComponentProps<typeof sonnerToast>, "position">) =>
      toast({ title: message, variant: "destructive", ...options }),
    success: (message: string, options?: Omit<React.ComponentProps<typeof sonnerToast>, "position">) =>
      toast({ title: message, ...options }),
    toasts: [], // Add empty toasts array to match expected interface
  };
};

export const toast = ({ title, description, action, variant = "default", ...props }: ToastProps) => {
  return sonnerToast(title as string, {
    description,
    action,
    className: variant === "destructive" ? "bg-destructive text-destructive-foreground" : undefined,
    duration: 5000,
    ...props,
  });
};
